import React from 'react';
import {Grid} from '@material-ui/core'
import './style.scss'
import {insta, linkedin, location, mail1, social4, social5, twitter} from './../../assets/images/images'

function Index(props) {
  const {auth = false} = props
  return (
    <Grid container style={{overflow: 'hidden'}} className='footer'>
      {!auth &&
      <Grid
        container
        className='footer-top-container bg-green display-flex  justify-content-between'
        justify='space-between' alignItems={'flex-start'}>
        <Grid container md={6} sm={7} xs={12}>
          {/*<h1 className='white-color'>Subscribe our newsletter for newest market updates</h1>*/}
          <h1 className='white-color'>Customer feedback form</h1>
        </Grid>
        <Grid container md={6} sm={5} xs={12} className='footer-input-container mt-10 '>
          <input style={{maxWidth: '70%', flexGrow: 1}} className='footer-input' placeholder='Type your email here'/>
          <button>subscribe</button>
        </Grid>
      </Grid>
      }

      <Grid container style={{paddingLeft: '7%', paddingRight: '7%',}}>
        <Grid item md={6} lg={6} style={{background: 'red5'}}>
          <Grid container md={12} direction='column' alignItems='center'
                style={{paddingTop: 20}}>
            <Grid item>
              <p className='font-14 black-color'>An AI-powered marketplace connecting smallholder farmers directly to fair, verified markets — seed to table. Our solution addresses food trust, traceability, payment security and market access across the food supply chain, backed by our grading and quality-verification services.</p>
            </Grid>
            <Grid container spacing={2} justify={'center'}>
              <Grid item className='m-10'>
                <a href="https://www.facebook.com/agrilivemarket" target={1}>
                  <img src={social5} alt='fb'/>
                </a>
              </Grid>
              <Grid item className='m-10'>
                <a href="https://www.youtube.com/watch?v=vWZECtF0wy4" target={3}>
                  <img src={social4} alt='Youtube'/>
                </a>
              </Grid>
              <Grid item className='m-10'>
                <img src={twitter} alt='Twitter'/>

              </Grid>
              <Grid item className='m-10'>
                <a href="https://www.linkedin.com/company/agrilivemarket" target={2}>

                  <img src={linkedin} alt='LinkedIn'/>
                </a>
              </Grid>
              <Grid item className='m-10'>
                <img src={insta} alt='Insta'/>

              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={3}>
          <Grid container direction='column' alignItems='center' style={{padding: 20}}>
            <Grid item>
              <p className='font-16 text-bold'>Get in Touch With Us</p>
            </Grid>
            <Grid style={{}}>
              <Grid container alignItems='center'>
                <img src={location} alt='youtube'/>
                <p className='ml-10 font-12'>Islamabad, Pakistan</p>
              </Grid>
              <Grid container alignItems='center' spacing={0}>
                <img src={location} alt='youtube'/>

                <p className='ml-10 font-12'>DIFC Dubai, UAE</p>
              </Grid>
              <Grid container alignItems='center' spacing={0}>
                <img src={mail1} alt='youtube'/>

                <p className='ml-10 font-12'>info@agrilivemarket.com</p>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item md={4}>*/}
          {/*  <Grid container md={12} direction='column' alignItems='center'*/}
          {/*        style={{padding: 30}}>*/}
          {/*    <Grid item>*/}
          {/*      /!*<p>AgriLive Market Peterdraw lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod*!/*/}
          {/*      /!*  tempor*!/*/}
          {/*      /!*  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.</p>*!/*/}
          {/*    </Grid>*/}
          {/*    <Grid>*/}
          {/*      /!*<Download/>*!/*/}
          {/*    </Grid>*/}
          {/*  </Grid>*/}
          {/*</Grid> */}

        </Grid>

        <Grid item md={3}>
          <Grid container md={10} direction='column' alignItems='center'
                style={{padding: 20}}>
            <Grid item>
              <p className='font-16 text-bold'>About Us and Policy</p>
            </Grid>
            <Grid style={{}}>
              <a className="cursor-pointer" href="/aboutUs">
                <Grid container alignItems='center' spacing={0}>


                  <p className='ml-10 font-12'>About us</p>
                </Grid>
              </a>
              <a className="cursor-pointer" href="/privacyPage">
                <Grid container alignItems='center' spacing={0}>
                  <p className='ml-10 font-12'>Policy and Terms</p>
                </Grid>
              </a>
            </Grid>
          </Grid>
        </Grid>

      </Grid>

    </Grid>

  );
}

export default Index;

// https://www.linkedin.com/company/agrilivemarket linkedin url


